import React from "react";
import StyledOutlineButton from "../../../../../components/Classroom/StyledOutlineButton";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import MultipleFilterDropdown from "../../../../../components/Classroom/MultipleFiltersDropdown";
import ImportLiveClassesModal from "../../ImportLiveClassesModal";

const LiveClassHeader = ({
  id,
  classId,
  permissions,
  filterOptions,
  selectedFilters,
  setSelectedFilters,
  resetFilters,
  applyFilters,
  appliedFilters,
  isMobileView,
  setOpenImportModal,
  openImportModal,
  refreshCompletedOnes,
}) => {
  const navigate = useNavigate();

  return (
    <div className="live-class-header">
      <div className="header-top">
        <h2 className="header-title">Live Classes</h2>
        <div className="action-container">
          {permissions.create && (
            <div className="action-buttons">
              <StyledOutlineButton
                btnText={"Create Single Live Class"}
                onClick={() => {
                  navigate(
                    `/classrooms/create/create-single-live-class?classroom=${id}&classDetailsPage=${
                      classId === ""
                    }`
                  );
                }}
              />
              <StyledOutlineButton
                style={{ marginLeft: "10px" }}
                btnText={"Create Bulk Live Classes"}
                onClick={() => {
                  navigate(
                    `/classrooms/create/create-bulk-live-class?classroom=${id}&classDetailsPage=${
                      classId === ""
                    }`
                  );
                }}
              />

              {!isMobileView && (
                <StyledOutlineButton
                  style={{ marginLeft: "10px" }}
                  btnText={"Import"}
                  onClick={() => {
                    setOpenImportModal(true)
                  }}
                />
              )}

              <MultipleFilterDropdown
                style={{ marginLeft: "10px" }}
                alignHeight
                marginRight="10px"
                categories={["teachers", "subjects"]}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                dateJoined={false}
                isApplied={
                  appliedFilters?.teachers?.length ||
                  appliedFilters?.subjects?.length
                }
                options={filterOptions}
                resetFilters={resetFilters}
                applyFilters={applyFilters}
              />
            </div>
          )}
        </div>
      </div>

      {/* <div className="filter-container">
        <EnhancedFilters
          filterOptions={filterOptions}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          resetFilters={resetFilters}
          applyFilters={applyFilters}
        />
      </div> */}
    {isMobileView && (
      <StyledOutlineButton
        style={{ marginLeft: "10px" }}
        btnText={"Import"}
        onClick={() => {
          setOpenImportModal(true)
        }}
      />
    )}
    {openImportModal ? <ImportLiveClassesModal isOpen={openImportModal} onClose={() => setOpenImportModal(false)} classroomId={id} onSuccess={refreshCompletedOnes} /> : ''}
    </div>
  );
};

export default LiveClassHeader;
